export const getCta = (payload: string | string[] = []): string[] => {
  if (typeof payload === 'string' && payload.length > 0) {
    return [payload]
  }

  if (Array.isArray(payload)) {
    return payload
  }

  return []
}
